import StarterDeckSelectContainer from '../../lobby/containers/starterDeckSelectContainer';
import { definePrefab, stubClip } from '../prefab';

export const starterDeckSelectPrefab = definePrefab({
    id: 'starterDeckSelect',
    name: 'Starter deck select',
    load: async () => {
        await StarterDeckSelectContainer.loadItemAssets(StarterDeckSelectContainer.previewItems());
    },
    create: () => StarterDeckSelectContainer.createPreview(),
    parts: {
        background: { name: 'Background', pick: (root) => root.background },
        title: { name: 'Title', pick: (root) => root.title },
        prevPrevDeck: { name: 'Previous previous deck', pick: (root) => root.prevPrevDeck },
        leftDeck: { name: 'Left deck', pick: (root) => root.leftDeck },
        centerDeck: { name: 'Center deck', pick: (root) => root.centerDeck },
        rightDeck: { name: 'Right deck', pick: (root) => root.rightDeck },
        nextNextDeck: { name: 'Next next deck', pick: (root) => root.nextNextDeck },
        prevName: { name: 'Previous name', pick: (root) => root.prevName },
        deckName: { name: 'Deck name', pick: (root) => root.deckName },
        nextName: { name: 'Next name', pick: (root) => root.nextName },
        prevDescription: { name: 'Previous description', pick: (root) => root.prevDescription },
        description: { name: 'Description', pick: (root) => root.description },
        nextDescription: { name: 'Next description', pick: (root) => root.nextDescription },
        claimButton: { name: 'Claim button', pick: (root) => root.claimButton },
    },
    clips: [
        stubClip('slide-left', () => import('../clips/starterDeckSelect/slide-left.json')),
        stubClip('slide-right', () => import('../clips/starterDeckSelect/slide-right.json')),
    ],
});
